import styled from "@emotion/styled";

export const ChartSettingOrderedSimpleRoot = styled.div`
  padding-left: 1rem;
  padding-bottom: 0.5rem;
`;

export const ChartSettingMessage = styled.div`
  margin: 1rem 0;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--mb-color-bg-light);
  color: var(--mb-color-text-light);
  font-weight: 700;
  border-radius: 0.5rem;
`;
